import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataInicio = (): TabelaColuna => ({
  Chave: 'dataInicio',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataInicio)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Início</div>
})
